<div
  *ngIf="
    params.mode == 'number' ||
    params.mode == 'currency' ||
    params.mode == 'percent' ||
    params.mode == 'per-hour'
  "
  class="input-group"
  style="height: 33px; margin: 3px 0 0 0; border: none">
  <div *ngIf="params.mode == 'currency'" class="input-group-prepend">
    <span class="input-group-text">$</span>
  </div>
  <input
    #inputField
    appNumberInput
    class="form-control"
    [(ngModel)]="params.value"
    [decimals]="params.decimals != undefined && params.decimals != null ? params.decimals : 2"
    [allowSpacePress]="true"
    style="height: 33px; border: none; padding-left: 5px; padding-right: 5px"
    placeholder="0.00" />
  <div *ngIf="params.mode == 'percent'" class="input-group-append">
    <span class="input-group-text">%</span>
  </div>
  <div *ngIf="params.mode == 'per-hour'" class="input-group-append">
    <span class="input-group-text"><small>/hr</small></span>
  </div>
</div>
